import React from "react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function Pages() {
  const location = useLocation();
  const navigate = useNavigate();
  const cms = location.state?.cms || {};

  const path = location.pathname;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [path]);

  const getContent = () => {
    switch (path) {
      case "/terms_conditions":
        return cms.termsAndConditions || "<p>No content found</p>";
      case "/privacy_policy":
        return cms.privacyPolicy || "<p>No content found</p>";
      case "/return_policy":
        return cms.returnsPolicy || "<p>No content found</p>";
      case "/cancellation_policy":
        return cms.cancellationPolicy || "<p>No content found</p>";
      case "/shipping_return_policy":
        return cms.paymentSecurity || "<p>No content found</p>";
      case "/track_order":
        return "<p>Tracking information feature coming soon!</p>";
      default:
        return "<p>No content available</p>";
    }
  };

  const getTitle = () => {
    switch (path) {
      case "/terms_conditions":
        return "Terms & Conditions";
      case "/privacy_policy":
        return "Privacy Policy";
      case "/return_policy":
        return "Return Policy";
      case "/cancellation_policy":
        return "Cancellation Policy";
      case "/shipping_return_policy":
        return "Shipping & Return Policy";
      case "/track_order":
        return "Track Your Order";
      default:
        return "Policies";
    }
  };

  return (
    <div className="min-h-screen mt-4 px-6 md:px-20 ">
      <h1 className="text-[32px] text-center font-bold mb-8">
        {getTitle()}
      </h1>

      <div
        className="prose max-w-7xl mx-auto text-gray-800"
        dangerouslySetInnerHTML={{ __html: getContent() }}
      />
    </div>
  );
}
